"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { ChevronRight, Link2 } from "lucide-react";
import { footerQuickLinks } from "@/content/footer";
import { cn } from "@/lib/utils";

export function FooterQuickLinks() {
  const pathname = usePathname();

  return (
    <>
      <h4 className="footer-heading mb-3 flex items-center gap-2 text-sm font-semibold text-accent">
        <Link2 size={16} className="footer-heading-icon shrink-0" />
        Quick Links
      </h4>
      <ul className="space-y-2">
        {footerQuickLinks.map((link) => {
          const active =
            link.href === "/"
              ? pathname === "/"
              : link.href === "/account"
                ? pathname === "/account"
                : pathname.startsWith(link.href);

          return (
            <li key={link.href}>
              <Link
                href={link.href}
                className={cn(
                  "footer-link group flex items-center gap-1 text-sm transition-colors hover:text-accent",
                  active ? "font-medium text-accent" : "text-muted"
                )}
              >
                <ChevronRight
                  size={12}
                  className="footer-link-icon shrink-0 transition-transform group-hover:translate-x-0.5"
                />
                {link.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}
